module.exports = __webpack_public_path__ + "static/img/g_3_tick.aa8b849e.png";